function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useRef, useEffect, useMemo } from 'react';
import { Form, OverlayTrigger, Popover } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { disabledBecauseOfClaimState } from './claimState';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util/FormattedNumberInput';
import { getTooltipWithText } from './helpers/getTooltipWithText';
export function ChangeHighlighter(_ref) {
  let {
    name,
    object,
    disabled,
    as: As,
    controlAs,
    ...props
  } = _ref;
  const value = (object || {})[name] || null;
  const originalValue = (object?.original_values || {})[name] || null;
  const user = useSelector(state => state.auth.user);
  const [show, setShow] = useState(false);
  const [currentValue, setCurrentValue] = useState(value);
  const widthElement = useRef(null);
  const inputContainer = useRef(null);
  const isTextControl = props.type === 'text' && As !== FormattedNumberInput;
  const changeExists = (object?.original_values || {})[name] !== undefined && value !== originalValue;
  let className = '';
  if (changeExists) {
    className = 'border border-info';
  }
  let wrapperStyle = {};
  if (As === Form.Control || As === FormattedNumberInput) {
    // we need a special style here to make it work
    wrapperStyle = {
      display: 'flex',
      flexDirection: 'row',
      flex: 1
    };
  }
  useEffect(() => {
    if (inputContainer.current) {
      widthElement.current.innerText = object[name];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widthElement.current, object]);
  const onInputChange = e => {
    setCurrentValue(e.target.value);
    widthElement.current.innerText = e.target.value;
    props.onChange && props.onChange(e);
  };
  const controlOnChange = isTextControl ? onInputChange : props.onChange;
  const control = /*#__PURE__*/React.createElement(As, _extends({
    name: name,
    value: isTextControl ? currentValue : value || '',
    checked: value || false,
    selected: value,
    disabled: disabled || disabledBecauseOfClaimState(user, object),
    as: controlAs
  }, props, {
    onChange: controlOnChange
  }));

  // using hidden div with the same text to calculate width of the text and show tooltip if needed
  const showContentTooltip = useMemo(() => {
    return props.type === 'text' && widthElement.current && widthElement.current.offsetWidth > inputContainer.current.offsetWidth - (props.size === 'sm' ? 17 : 25);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue, widthElement.current, inputContainer.current]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: showContentTooltip ? getTooltipWithText(object[name]) : /*#__PURE__*/React.createElement("div", null)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    ref: widthElement,
    className: `width_comparison_contanier ${props.size || 'md'}`
  }), /*#__PURE__*/React.createElement(OverlayTrigger, {
    show: changeExists && show,
    trigger: ['hover', 'focus'],
    onToggle: () => setShow(!show),
    placement: "top",
    overlay: `Original Value: ${originalValue === null ? 'null' : originalValue.toString()}`
  }, /*#__PURE__*/React.createElement("div", {
    ref: inputContainer,
    className: className,
    style: wrapperStyle
  }, control)))));
}